export const caughtErrorMessage = (error: unknown, fallback: string): string => {
  if (!(error instanceof Error)) return fallback;
  const message = error.message.trim();
  return message === "" ? fallback : message;
};

export const caughtThrowableMessage = (error: unknown, fallback: string): string => {
  const message = error instanceof Error
    ? error.message
    : typeof error === "string"
      ? error
      : "";
  const cleaned = message.trim();
  return cleaned === "" ? fallback : cleaned;
};

export const prefixedCaughtErrorMessage = (
  error: unknown,
  prefix: string,
  fallback: string,
): string => {
  const message = caughtErrorMessage(error, "");
  return message === "" ? fallback : prefix + message;
};
